/**
 * 图形验证码：namespace 生成与拉图 URL
 * namespace 须满足 /^[A-Za-z0-9]{8,32}$/
 */

const hostUrl = typeof window !== 'undefined' && window.location.href.indexOf('yyddi') !== -1
  ? '/yyddi/'
  : './';

/** 与 td-app-admin / PC 一致：10 位数字 namespace */
export function generateCaptchaNamespace(): string {
  return 'xxxxxxxxxx'.replace(/[xy]/g, () => {
    return ((Math.random() * 10) | 0).toString();
  });
}

/**
 * 学员端拉图地址（二进制 PNG，可直接作 img src）
 */
export function getLearnerCaptchaUrl(namespace: string): string {
  return `${hostUrl}ddilearner/v1/user/captcha?namespace=${encodeURIComponent(namespace)}&t=${Date.now()}`;
}

/**
 * 验图请求一次消费：成功、失败、网络错误后都要换新图再提交。
 */
export function shouldAutoRefreshCaptcha(msg?: any): boolean {
  return true;
}



// WEBPACK FOOTER //
// ./src/app/captcha.util.ts